module.exports = __webpack_public_path__ + "img/u995.fc7c6b4e.png";